import { Component } from '@angular/core';
import { IonicPage, ToastController, PopoverController, Popover, ActionSheetController, LoadingController } from 'ionic-angular';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { APIOnLine } from '../../services/api/api.services';
import { Alineados } from '../../models/designaciones';
import { PaginaBasica } from '../../models/PaginaBase';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';
import { Proxy } from '../../services/proxy/proxy.service';

export interface iParticipante {
  alineado: Alineados,
  participa: boolean
}

@IonicPage()
@Component({
  selector: 'page-participacion',
  templateUrl: 'participacion.html',
})
export class ParticipacionPage extends PaginaBasica {

  //#region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  //#endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public Persistentes: APIOnLine.Persistentes,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('--- ENTRO EN LA PÁGINA: PARTICIPACIÓN ---');

    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    this.MostrarOcultarCarga(false, "cargando alineados");

    this.licencias = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);
    this.participantes = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);

    this.participantes.CargarListaParticipacion()
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(true, false, false);
      })
      .then((resultado: boolean) => {
        this.MostrarOcultarCarga();
      })
      .catch(error => this.Error(error, "ERROR al obtener los alineados del equipo actual"));
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event
    });
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/participacion/participacion.ts